import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import api from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts").then((res) => setPosts(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="grain relative min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary mb-5">/ The Journal</p>
          <h1 data-testid="blog-title" className="font-display font-black uppercase tracking-tighter leading-[0.85] text-5xl sm:text-6xl lg:text-7xl">
            Notes on<br /><span className="text-primary">wealth & cashflow</span>
          </h1>

          {loading ? (
            <p className="mt-16 font-mono-accent text-sm text-muted-foreground">Loading journal...</p>
          ) : posts.length === 0 ? (
            <p data-testid="blog-empty" className="mt-16 font-mono-accent text-sm text-muted-foreground">No articles yet. Check back soon.</p>
          ) : (
            <div className="mt-16 border-t border-border">
              {posts.map((p, i) => (
                <motion.div
                  key={p.id}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                >
                  <Link
                    data-testid={`blog-item-${i}`}
                    to={`/blog/${p.slug}`}
                    className="group grid grid-cols-1 md:grid-cols-12 gap-6 py-10 border-b border-border hover:bg-card transition-colors px-2 md:px-4"
                  >
                    <div className="md:col-span-4 aspect-[16/10] overflow-hidden border border-border">
                      <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                    <div className="md:col-span-8 flex flex-col justify-center">
                      <div className="flex items-center gap-3 font-mono-accent text-[11px] uppercase tracking-[0.15em] text-primary mb-3">
                        <span>{p.category}</span>
                        <span className="text-muted-foreground">— {p.read_time}</span>
                      </div>
                      <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-4xl leading-tight group-hover:text-primary transition-colors">
                        {p.title}
                      </h2>
                      <p className="text-muted-foreground text-base mt-3 leading-relaxed max-w-2xl line-clamp-2">{p.excerpt}</p>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
